import { render, staticRenderFns } from "./PreRegistrationSent.vue?vue&type=template&id=0753105f&scoped=true"
import script from "./PreRegistrationSent.vue?vue&type=script&lang=js"
export * from "./PreRegistrationSent.vue?vue&type=script&lang=js"
import style0 from "./PreRegistrationSent.vue?vue&type=style&index=0&id=0753105f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0753105f",
  null
  
)

export default component.exports